import React, { useEffect, useState } from 'react';
const dataTypeOptions = ['Text', 'Number', 'Yes/No', 'Date', 'Money', 'List'];
const AddAttributeForm = ({
  onSubmit,
  onCancel,
  initialData
}) => {
  const [formData, setFormData] = useState({
    name: '',
    dataType: 'Text',
    listItems: ''
  });
  useEffect(() => {
    if (initialData) {
      // If editing an existing attribute, populate the form
      let listItems = '';
      let dataType = initialData.dataType;
      if (dataType.startsWith('List:')) {
        listItems = dataType.substring(6).trim();
        dataType = 'List';
      }
      setFormData({
        name: initialData.name,
        dataType: dataType,
        listItems: listItems
      });
    }
  }, [initialData]);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Format the data for submission
    let dataToSubmit = {
      ...formData
    };
    // If it's a list type, format it properly
    if (formData.dataType === 'List' && formData.listItems.trim()) {
      dataToSubmit.dataType = `List: ${formData.listItems.trim()}`;
    }
    // Remove the listItems field before submitting
    const {
      listItems,
      ...finalData
    } = dataToSubmit;
    // If editing, preserve the ID
    if (initialData) {
      finalData.id = initialData.id;
    }
    onSubmit(finalData);
  };
  return <form onSubmit={handleSubmit} className="space-y-4" data-id="element-11">
      <div data-id="element-12">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-13">
          Attribute Name
        </label>
        <input type="text" name="name" id="name" required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={formData.name} onChange={handleChange} placeholder="e.g., Pool, Grill, etc." data-id="element-14" />
      </div>
      <div data-id="element-15">
        <label htmlFor="dataType" className="block text-sm font-medium text-gray-700" data-id="element-16">
          Data Type
        </label>
        <select name="dataType" id="dataType" required className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={formData.dataType} onChange={handleChange} data-id="element-17">
          {dataTypeOptions.map(option => <option key={option} value={option} data-id="element-18">
              {option}
            </option>)}
        </select>
      </div>
      {formData.dataType === 'List' && <div data-id="element-19">
          <label htmlFor="listItems" className="block text-sm font-medium text-gray-700" data-id="element-20">
            List Items
          </label>
          <textarea name="listItems" id="listItems" rows={4} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" value={formData.listItems} onChange={handleChange} placeholder="Put one list item on each line" data-id="element-21" />
        </div>}
      <div className="flex justify-end space-x-3 pt-2" data-id="element-22">
        <button type="button" onClick={onCancel} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" data-id="element-23">
          Cancel
        </button>
        <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-opacity" style={{
        backgroundColor: '#332275'
      }} data-id="element-24">
          {initialData ? 'Update Attribute' : 'Add Attribute'}
        </button>
      </div>
    </form>;
};
export default AddAttributeForm;